import db from 'mime-db';
import { EXTENSION_POLICY } from '../../const';

const mimetypeDatabase = Object.keys(db);

const getWildcardsTypes = mimetypes =>
  mimetypes
    .split(',')
    .filter(mimetype => mimetype.includes('*'))
    .map(wildcard => wildcard.slice(0, -1));

const getMimetypes = mimetypes => mimetypes.split(',').filter(mimetype => !mimetype.includes('*'));

const getBlackList = (wildcardsTypesArray, mimetypesArray) =>
  mimetypeDatabase
    .filter(mimetype => !wildcardsTypesArray.includes(mimetype))
    .filter(mimetype => !mimetypesArray.includes(mimetype))
    .join(',');

export const getAcceptedMimetypes = (mimetypes, mimetypePolicy) => {
  if (mimetypePolicy === EXTENSION_POLICY.ALLOW) {
    return mimetypes;
  }
  const wildcardsTypesArray = getWildcardsTypes(mimetypes);
  const mimetypesArray = getMimetypes(mimetypes);
  return getBlackList(wildcardsTypesArray, mimetypesArray);
};

export const getMimetypeFromFile = fileName => {
  if (fileName) {
    const extension = fileName.slice(((fileName.lastIndexOf('.') - 1) >>> 0) + 2).toLowerCase();
    for (let mimetype in db) {
      if (db[mimetype].extensions && db[mimetype].extensions.includes(extension)) {
        return mimetype;
      }
    }
  }
};

export const getExtensionFromMimetype = mimetype => {
  if (mimetype) {
    if (!db[mimetype.toLowerCase()]) {
      return mimetype === 'web/resource' ? 'link' : '';
    }

    return db[mimetype.toLowerCase()].extensions ? db[mimetype.toLowerCase()].extensions[0] : '';
  }
};
